<div class="invoice-page">
  <section>
    <kendo-gridlayout [rows]="['auto']" [gap]="{rows: 5, cols: 16}" [cols]="['repeat(2,minmax(0,1fr))']">
      <kendo-gridlayout-item class="mb-0">
        <ng-container *ngIf="investigation; else unlinked">
          <h4 class="page-title">{{ !data?.disableEdit ? "Send" : "Sent" }} to Sage</h4>
          <p class="invoice-subtitle">Investigation# {{ investigation?.nefcoNumber || investigation?.id }}</p>
        </ng-container>
        <ng-template #unlinked>
          <h4 class="page-title">Unlinked Entry</h4>
        </ng-template>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item class="text-right mb-0">
        <button kendoButton themeColor="light" fillMode="solid" (click)="cancel()">Back</button>
      </kendo-gridlayout-item>
    </kendo-gridlayout>
    <!-- Invoice number and bill tos -->
    <kendo-card [width]="'100%'" class="mt-12">
      <kendo-card-body>
        <div class="section-header">
          <h2 class="mb-0">Invoice Information</h2>
        </div>
        <kendo-card [width]="'100%'" class="mt-16">
          <kendo-card-body class="p-0 inner-card-body card-detail">
            <kendo-gridlayout [rows]="['auto']" [gap]="{rows: 16, cols: 16}" [cols]="['repeat(3,minmax(0,1fr))']">
              <kendo-gridlayout-item class="mb-0" [colSpan]="3">
                <span>
                  Invoice Number
                </span>
                <div class="mt-1">
                  <kendo-formfield *ngIf="!data?.disableEdit; else viewOnly_InvoiceNum;">
                    <kendo-textbox
                      id="invoiceNumber"
                      [(ngModel)]="invoiceNumber"
                      placeholder="Invoice Number"
                      fillMode="outline"
                      [required]="true"
                      [maxlength]="invoiceNumberMaxLength"
                      [clearButton]="false">
                    </kendo-textbox>
                    <kendo-formhint *ngIf="!data?.invoice && additionalBillTos.length">
                      Letters A, B, C... are added automatically for each Bill To.
                    </kendo-formhint>
                  </kendo-formfield>
                  <ng-template #viewOnly_InvoiceNum><p class="mt-1">{{ data?.invoice?.invoiceNumber }}</p></ng-template>
                  <div class="mt-1" *ngIf="data?.invoice?.splitGroupId">
                    <kendo-badge class="fw600" position="none" size="medium" rounded="full" themeColor="info">
                      Split {{ data.invoice.splitPercentage | number:'1.2-2' }}%
                    </kendo-badge>
                    <p class="mt-1 mb-0" *ngIf="siblingInvoiceNumbers.length">
                      Other invoices of this split: {{ siblingInvoiceNumbers.join(', ') }}
                    </p>
                    <p class="mt-1 mb-0" *ngIf="!data?.disableEdit">The lines and Bill To of a split invoice cannot be changed, only its number and details.</p>
                  </div>
                </div>
              </kendo-gridlayout-item>

              <kendo-gridlayout-item class="mb-0">
                <span>
                  Client
                </span>
                <p class="mt-1 mb-0">{{ investigation?.Client?.firstName }} {{ investigation?.Client?.lastName }}</p>
                <p class="mt-1 mb-0">{{ investigation?.ClientBranch?.Company?.name }}</p>
                <p class="mt-1">{{ investigation?.ClientBranch?.name }}</p>
              </kendo-gridlayout-item>

              <kendo-gridlayout-item class="mb-0">
                <span>
                  Bill To
                </span>
                <ng-container *ngTemplateOutlet="billToDetails; context: { contact: billToContact, branch: billToBranch }"></ng-container>
                <ng-container *ngIf="additionalBillTos.length && primaryBillTo">
                  <span>
                    Percentage
                  </span>
                  <p class="mt-1">
                    {{ primaryBillTo.percentage !== null && primaryBillTo.percentage !== undefined ? (primaryBillTo.percentage | number:'1.2-2') + '%' : '-' }}
                  </p>
                </ng-container>
              </kendo-gridlayout-item>

              <kendo-gridlayout-item class="mb-0" *ngFor="let additionalBillTo of additionalBillTos">
                <span>
                  Additional Bill To
                </span>
                <ng-container *ngTemplateOutlet="billToDetails; context: { contact: additionalBillTo.BillTo, branch: additionalBillTo.BillToBranch }"></ng-container>
                <span>
                  Percentage
                </span>
                <p class="mt-1">
                  {{ additionalBillTo.percentage !== null && additionalBillTo.percentage !== undefined ? (additionalBillTo.percentage | number:'1.2-2') + '%' : '-' }}
                </p>
              </kendo-gridlayout-item>

              <kendo-gridlayout-item class="mb-0">
                <span>
                  NEFCO Office
                </span>
                <p class="mt-1">{{ investigation?.NefcoOffice?.name || '-' }}</p>
              </kendo-gridlayout-item>
            </kendo-gridlayout>
          </kendo-card-body>
        </kendo-card>
      </kendo-card-body>
    </kendo-card>

    <!-- Billing information, header collapses the card -->
    <kendo-card [width]="'100%'" class="mt-16">
      <kendo-card-body>
        <div class="section-header cursor" role="button" [attr.aria-expanded]="!isBillingInfoCollapsed"
          (click)="isBillingInfoCollapsed = !isBillingInfoCollapsed">
          <h2 class="mb-0">Billing Information</h2>
          <i class="fa-solid" [ngClass]="isBillingInfoCollapsed ? 'fa-caret-down' : 'fa-caret-up'"></i>
        </div>
        <kendo-card *ngIf="!isBillingInfoCollapsed" [width]="'100%'" class="mt-16">
          <kendo-card-body class="p-0 inner-card-body card-detail">
            <kendo-gridlayout [rows]="['auto']" [gap]="{rows: 16, cols: 16}" [cols]="['repeat(2,minmax(0,1fr))']">
              <kendo-gridlayout-item class="mb-0" [colSpan]="2">
                <span>
                  Special Billing Instructions
                </span>
                <p class="mt-1 mb-0 preserve-newlines">{{ investigation?.Detail?.specialInstructions || '-' }}</p>
              </kendo-gridlayout-item>

              <kendo-gridlayout-item class="mb-0" [colSpan]="2">
                <span>
                  Evidence Billing
                </span>
                <kendo-gridlayout class="mt-1" [rows]="['auto']" [gap]="{rows: 5, cols: 16}" [cols]="['repeat(5,minmax(0,1fr))']">
                  <kendo-gridlayout-item class="mb-0">
                    <span>
                      Bill Rate
                    </span>
                    <p class="mt-1">{{ investigation?.EvidenceBilling?.rate ?? '-' }}</p>
                  </kendo-gridlayout-item>
                  <kendo-gridlayout-item class="mb-0">
                    <span>
                      Billing Schedule
                    </span>
                    <p class="mt-1">{{ investigation?.EvidenceBilling?.BillingFrequency?.name || '-' }}</p>
                  </kendo-gridlayout-item>
                  <kendo-gridlayout-item class="mb-0">
                    <span>
                      Billing Date
                    </span>
                    <p class="mt-1" *ngIf="investigation?.EvidenceBilling?.startDate; else noValue"
                      [textContent]="investigation.EvidenceBilling.startDate | customDate: 'MM-dd-yyyy'"></p>
                  </kendo-gridlayout-item>
                  <kendo-gridlayout-item class="mb-0">
                    <span>
                      Billable
                    </span>
                    <p class="mt-1">{{ investigation?.EvidenceBilling?.billable ? 'Yes' : 'No' }}</p>
                  </kendo-gridlayout-item>
                  <kendo-gridlayout-item class="mb-0">
                    <span>
                      Notes
                    </span>
                    <p class="mt-1" *ngIf="investigation?.EvidenceBilling?.notes; else noValue"
                      [textContent]="investigation.EvidenceBilling.notes"></p>
                  </kendo-gridlayout-item>
                </kendo-gridlayout>
              </kendo-gridlayout-item>

              <kendo-gridlayout-item class="mb-0" [colSpan]="2">
                <span>
                  Billing Rate Overrides
                </span>
                <!-- two overrides per row -->
                <kendo-gridlayout class="mt-1" *ngIf="investigation?.Company?.BillingRules?.length; else noValue"
                  [rows]="['auto']" [gap]="{rows: 5, cols: 32}" [cols]="['repeat(2,minmax(0,1fr))']">
                  <kendo-gridlayout-item class="mb-0" *ngFor="let rule of investigation.Company.BillingRules">
                    <kendo-gridlayout [rows]="['auto']" [gap]="{rows: 5, cols: 16}" [cols]="['repeat(3,minmax(0,1fr))']">
                      <kendo-gridlayout-item class="mb-0">
                        <span>
                          Category
                        </span>
                        <p class="mt-1" [textContent]="rule?.ExpenseItem?.id ? 'Expense' : 'Hours'"></p>
                      </kendo-gridlayout-item>
                      <kendo-gridlayout-item class="mb-0">
                        <span>
                          Type
                        </span>
                        <p class="mt-1" [textContent]="rule?.ExpenseItem?.id ? rule?.ExpenseItem?.name : rule?.TimeEntryType?.name"></p>
                      </kendo-gridlayout-item>
                      <kendo-gridlayout-item class="mb-0">
                        <span>
                          Rate
                        </span>
                        <p class="mt-1">${{ rule.value }} /hr</p>
                      </kendo-gridlayout-item>
                    </kendo-gridlayout>
                  </kendo-gridlayout-item>
                </kendo-gridlayout>
              </kendo-gridlayout-item>

              <kendo-gridlayout-item class="mb-0">
                <span>
                  Flat Rate for Standard Investigations
                </span>
                <ng-container *ngIf="investigation?.Company?.FlatRates?.length; else noValue">
                  <kendo-gridlayout class="mt-1" *ngFor="let rate of investigation.Company.FlatRates" [rows]="['auto']"
                    [gap]="{rows: 5, cols: 16}" [cols]="['repeat(2,minmax(0,1fr))']">
                    <kendo-gridlayout-item class="mb-0">
                      <span>
                        Risk Type
                      </span>
                      <p class="mt-1" [innerHtml]="rate.Risk.name"></p>
                    </kendo-gridlayout-item>
                    <kendo-gridlayout-item class="mb-0">
                      <span>
                        Rate
                      </span>
                      <p class="mt-1">${{ rate.value }}</p>
                    </kendo-gridlayout-item>
                  </kendo-gridlayout>
                </ng-container>
              </kendo-gridlayout-item>

              <kendo-gridlayout-item class="mb-0">
                <span>
                  Budget Specified
                </span>
                <p class="mt-1 mb-0" *ngIf="investigation?.Detail?.budgetAmount; else noValue">{{ investigation.Detail.budgetAmount | currency }}</p>
              </kendo-gridlayout-item>

              <kendo-gridlayout-item class="mb-0" [colSpan]="2">
                <span>
                  Investigation Billing Instruction
                </span>
                <p class="mt-1 mb-0 preserve-newlines" *ngIf="investigation?.billingInstructions">{{ investigation.billingInstructions }}</p>
                <p class="mt-1 mb-0 preserve-newlines" *ngIf="investigation?.Detail?.billingInstructionNotes">{{ investigation.Detail.billingInstructionNotes }}</p>
                <p class="mt-1 mb-0" *ngIf="!investigation?.billingInstructions && !investigation?.Detail?.billingInstructionNotes">-</p>
              </kendo-gridlayout-item>
            </kendo-gridlayout>
          </kendo-card-body>
        </kendo-card>
      </kendo-card-body>
    </kendo-card>

    <div class="mt-16 mb-16" *ngIf="!data?.disableEdit && !this.data.invoice">
      <kendo-button kendoButton themeColor="primary" fillMode="solid" size="medium" [disabled]="selectedLines.length < 2 || !sameType" (click)="combine()">Combine Selected</kendo-button>
      <kendo-button kendoButton themeColor="error" fillMode="solid" size="medium" [disabled]="!selectedLines.length" class="ml-16" (click)="deleteLines()">Delete Selected</kendo-button>
    </div>

    <kendo-grid
      #dataTable
      class="quickbook-invoice-list td-16-8 mt-16 one-px-border"
      [data]="invoiceLines"
      [pageable]="false"
      [sortable]="false"
      [navigatable]="false"
      cdkDropList
      (cdkDropListDropped)="drop($event)"
    >
      <kendo-grid-column
        field="Select"
        title="#"
        [width]="8"
        [sortable]="false"
        [headerClass]="'nocursor'"
        *ngIf="!data.disableEdit && !data.invoice"
      >
        <ng-template kendoGridCellTemplate let-dataItem>
          <div>
            <kendo-button kendoButton themeColor="primary" fillMode="link" size="medium"
              iconClass="fa-solid fa-grip-lines" class="mr-16 example-drag-cursor" cdkDrag cdkDragLockAxis="y"></kendo-button>
            <div class="k-checkbox-wrap">
              <input
                kendoCheckBox
                name="select"
                type="checkbox"
                [(ngModel)]="dataItem.selected" />
            </div>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
          field="Date"
          title="Date"
          [width]="14"
          [sortable]="false"
          [headerClass]="'nocursor'"
        >
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="kendo-field mb-0">
              <kendo-formfield *ngIf="canEditLines; else viewOnly_date;">
                <kendo-datepicker
                    id="expenseDate"
                    name="expenseDate"
                    calendarType="classic"
                    [fillMode]="'outline'"
                    placeholder="Expense Date"
                    format="MM/dd/yyyy"
                    [(ngModel)]="dataItem.createdAt"
                    formatPlaceholder="formatPattern"
                    #expenseDate="ngModel"
                ></kendo-datepicker>
              </kendo-formfield>
              <ng-template #viewOnly_date><span *ngIf="dataItem.createdAt" [innerHtml]="dataItem.createdAt | customDate: 'MM/dd/yyyy'"></span></ng-template>
            </div>
          </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        field="Staff"
        title="Staff"
        [width]="12"
        [sortable]="false"
        [headerClass]="'nocursor'"
      >
        <ng-template kendoGridCellTemplate let-dataItem>
          <span class="">{{dataItem?.staffNames || '-'}}</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        field="Description"
        title="Description"
        [width]="14"
        [sortable]="false"
        [headerClass]="'nocursor'"
      >
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="kendo-field mb-0">
            <kendo-formfield *ngIf="canEditLines; else viewOnly_desc;">
              <kendo-textarea #descriptionField [(ngModel)]="dataItem.description" name="description"
                placeholder="Enter description" fillMode="outline" class="min-height-96" resizable="both"
                #description="ngModel" appNoWhiteSpace maxlength="4000">
              </kendo-textarea>
            </kendo-formfield>
            <ng-template #viewOnly_desc><span>{{dataItem.description}}</span></ng-template>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        field="Qty"
        title="Qty"
        [width]="10"
        [sortable]="false"
        [headerClass]="'nocursor'"
      >
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="kendo-field mb-0">
            <kendo-formfield *ngIf="canEditLines; else viewOnly_qty;">
              <div class="numeric-text-suffix">
                  <kendo-numerictextbox placeholder="Enter Qty" name="qty" fillMode="outline"
                  [autoCorrect]="true" [(ngModel)]="dataItem.quantity" [min]="0" [decimals]="4" format="0.####">
                  </kendo-numerictextbox>
              </div>
            </kendo-formfield>
            <ng-template #viewOnly_qty><span>{{dataItem.quantity | number:'1.0-4'}}</span></ng-template>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        field="Type"
        title="Type"
        [width]="10"
        [sortable]="false"
        [headerClass]="'nocursor'"
      >
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="kendo-field mb-0">
            <kendo-formfield *ngIf="canEditLines; else viewOnly_type;">
              <kendo-dropdownlist #category
                [data]="[{val: formExpenseType.MILEAGE, text: 'Mileage'}, {val: formExpenseType.EXPENSE, text: 'Expense'}, {val: formExpenseType.HOURS, text: 'Hours'}]"
                textField="text" valueField="val" [valuePrimitive]="true"
                [(ngModel)]="dataItem.ExpenseType.name" fillMode="outline" [filterable]="false"
                [popupSettings]="{appendTo: 'root', animate: false, width: 250 }">
                <ng-template kendoDropDownListValueTemplate let-dataItemDropDown>
                  <span class="not-placeholder"> {{ dataItemDropDown?.text }} </span>
                </ng-template>
              </kendo-dropdownlist>
            </kendo-formfield>
            <ng-template #viewOnly_type>{{dataItem?.ExpenseType?.name || dataItem?.expenseType}}</ng-template>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        field="sageId"
        title="Sage Item"
        [width]="10"
        [sortable]="false"
        [headerClass]="'nocursor'"
      >
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="kendo-field mb-0">
            <kendo-formfield *ngIf="canEditLines; else viewOnly_qbAccount;">
              <kendo-dropdownlist [data]="sageItems" name="sageItem" #sageItem="ngModel" [(ngModel)]="dataItem.sageId"
                (valueChange)="sageItemChange($event, dataItem)"
                [valuePrimitive]="true" fillMode="outline" textField="name" valueField="id"
                [defaultItem]="{name: 'Select Sage Item', id: null}" [popupSettings]="{appendTo: 'root', animate: false, width: 250}"
                required>
                <ng-template kendoDropDownListValueTemplate let-dataItem>
                  <span [ngClass]="dataItem?.id ? 'not-placeholder': 'placeholder'"> {{ dataItem.name }} </span>
                </ng-template>
              </kendo-dropdownlist>
              <kendo-formerror *ngIf="!sageItem?.valid && (sageItem?.dirty || sageItem?.touched)">
                <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                <span *ngIf="sageItem?.errors?.required">
                  Sage item cannot be left blank
                </span>
              </kendo-formerror>
            </kendo-formfield>
            <ng-template #viewOnly_qbAccount>{{ dataItem?.qbAccount }}</ng-template>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        field="Rate"
        title="Rate"
        [width]="10"
        [sortable]="false"
        [headerClass]="'nocursor'"
      >
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="kendo-field mb-0">
            <kendo-formfield *ngIf="canEditLines; else viewOnly_rate;">
              <div class="numeric-text-suffix">
                  <kendo-numerictextbox placeholder="Enter Rate" name="rate" fillMode="outline"
                  [autoCorrect]="false" [(ngModel)]="dataItem.rate">
                  </kendo-numerictextbox>
              </div>
            </kendo-formfield>
            <ng-template #viewOnly_rate>{{dataItem?.rate}}</ng-template>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        field="Total"
        title="Total"
        [width]="8"
        [sortable]="false"
        [headerClass]="'nocursor'"
      >
        <ng-template kendoGridCellTemplate let-dataItem>
          <span>{{dataItem.quantity * dataItem.rate | currency}}</span>
        </ng-template>
        <ng-template kendoGridFooterTemplate>
          <span style="margin-left: 4px;">{{total | currency}}</span>
        </ng-template>
      </kendo-grid-column>
    </kendo-grid>

    <!-- What each Bill To pays, recalculated from the lines above -->
    <kendo-card *ngIf="billToSplit as split" [width]="'100%'" class="mt-16">
      <kendo-card-body>
        <div class="section-header">
          <h2 class="mb-0">Bill To Split</h2>
        </div>
        <kendo-card [width]="'100%'" class="mt-16">
          <kendo-card-body class="p-0 inner-card-body card-detail">
            <p class="mb-0 text-danger" *ngIf="!split.isValid">
              <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
              <ng-container *ngIf="!split.error; else splitError">
                The Bill To percentages add up to {{ split.percentageTotal | number:'1.2-2' }}% instead of 100%, so the split cannot be shown.
              </ng-container>
              <ng-template #splitError>{{ split.error }}</ng-template>
            </p>
            <!-- One row per Bill To, expand a row to see its share of every line -->
            <kendo-grid *ngIf="split.isValid" class="td-16-8 one-px-border" [data]="split.columns" [pageable]="false"
              [sortable]="false" [navigatable]="false">
              <kendo-grid-column title="Bill To" [headerClass]="'nocursor'">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <p class="mb-0">{{ dataItem.name || '-' }} <span *ngIf="dataItem.sageId">({{ dataItem.sageId }})</span></p>
                  <p class="mb-0" *ngIf="invoiceNumber">Invoice# {{ invoiceNumber }}{{ billToLetter(rowIndex) }}</p>
                </ng-template>
                <ng-template kendoGridFooterTemplate>
                  <p class="mb-0">Total</p>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Company" [headerClass]="'nocursor'">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <p class="mb-0">{{ dataItem.company || '-' }}</p>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Percentage" [headerClass]="'nocursor'">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <p class="mb-0">{{ dataItem.percentage | number:'1.2-2' }}%</p>
                </ng-template>
                <ng-template kendoGridFooterTemplate>
                  <p class="mb-0">{{ split.percentageTotal | number:'1.2-2' }}%</p>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Amount" [headerClass]="'nocursor'">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <p class="mb-0">{{ split.invoices[rowIndex].total | currency }}</p>
                </ng-template>
                <ng-template kendoGridFooterTemplate>
                  <p class="mb-0">{{ split.total | currency }}</p>
                </ng-template>
              </kendo-grid-column>

              <ng-template kendoGridDetailTemplate let-billToIndex="rowIndex">
                <kendo-grid class="td-16-8" [data]="split.invoices[billToIndex].lines" [pageable]="false" [sortable]="false"
                  [navigatable]="false">
                  <kendo-grid-column title="Description" [headerClass]="'nocursor'">
                    <ng-template kendoGridCellTemplate let-line>
                      <p class="mb-0">{{ line.description }}</p>
                    </ng-template>
                    <ng-template kendoGridFooterTemplate>
                      <p class="mb-0">Total</p>
                    </ng-template>
                  </kendo-grid-column>

                  <kendo-grid-column title="Quantity" [headerClass]="'nocursor'">
                    <ng-template kendoGridCellTemplate let-line>
                      <p class="mb-0">{{ line.quantity | number:'1.0-4' }}</p>
                    </ng-template>
                  </kendo-grid-column>

                  <kendo-grid-column title="Rate" [headerClass]="'nocursor'">
                    <ng-template kendoGridCellTemplate let-line>
                      <p class="mb-0">{{ line.rate | currency }}</p>
                    </ng-template>
                  </kendo-grid-column>

                  <kendo-grid-column title="Amount" [headerClass]="'nocursor'">
                    <ng-template kendoGridCellTemplate let-line>
                      <p class="mb-0">{{ line.amount | currency }}</p>
                    </ng-template>
                    <ng-template kendoGridFooterTemplate>
                      <p class="mb-0">{{ split.invoices[billToIndex].total | currency }}</p>
                    </ng-template>
                  </kendo-grid-column>

                  <kendo-grid-column title="Line Total" [headerClass]="'nocursor'">
                    <ng-template kendoGridCellTemplate let-line>
                      <p class="mb-0">{{ line.lineAmount !== null && line.lineAmount !== undefined ? (line.lineAmount | currency) : '-' }}</p>
                    </ng-template>
                    <ng-template kendoGridFooterTemplate>
                      <p class="mb-0">{{ split.total | currency }}</p>
                    </ng-template>
                  </kendo-grid-column>
                </kendo-grid>
              </ng-template>
            </kendo-grid>
          </kendo-card-body>
        </kendo-card>
      </kendo-card-body>
    </kendo-card>

    <kendo-gridlayout [rows]="['auto']" [gap]="{rows: 0, cols: 16}" [cols]="['repeat(1,minmax(0,1fr))']" class="mt-16">
      <kendo-gridlayout-item>
        <kendo-formfield *ngIf="!data?.disableEdit; else viewOnly_details;">
          <kendo-textarea [(ngModel)]="details" name="details" placeholder="Invoice detail / instructions ..."
            fillMode="outline" class="min-height-96" resizable="both" appNoWhiteSpace>
          </kendo-textarea>
        </kendo-formfield>
        <ng-template #viewOnly_details>
          <h2>Invoice Detail / Instructions</h2>
          <p>{{ data?.invoice?.details || '-' }}</p>
        </ng-template>
      </kendo-gridlayout-item>
    </kendo-gridlayout>
  </section>
  <footer>
    <button kendoButton [size]="'medium'" themeColor="light" class="mr-8" (click)="cancel()">
      {{ !data?.disableEdit ? "Cancel" : "Close" }}
    </button>
    <button kendoButton [size]="'medium'" themeColor="primary" class="mr-16" *ngIf="!data.disableEdit"
      [disabled]="!investigation?.BillTo?.firstName || !(total > 0) || !billTosLoaded" (click)="send()">
      {{ investigation?.id ? "Send" : "Save" }}
    </button>
  </footer>
</div>

<ng-template #billToDetails let-contact="contact" let-branch="branch">
  <p class="mt-1 mb-0">{{ contact | fullName }} <span *ngIf="contact?.sageId">({{ contact.sageId }})</span></p>
  <p class="mt-1 mb-0" *ngIf="branch?.Company?.name" [textContent]="branch.Company.name"></p>
  <p class="mt-1" *ngIf="branch?.BillingAddress; else contactAddress" [innerHtml]="branch.BillingAddress | addressFormat"></p>
  <ng-template #contactAddress>
    <p class="mt-1" *ngIf="contact?.BillingAddress" [innerHtml]="contact.BillingAddress | addressFormat"></p>
  </ng-template>
</ng-template>

<ng-template #noValue>
  <p class="mb-0">-</p>
</ng-template>
